import React from 'react';
import { Spinner, Flex } from '@leagueplatform/genesis-commons';

export const Loading = () => (
  <Flex marginY="two" alignItems="center" justifyContent="center" height={24}>
    <Spinner isLoading data-testid="loading-spinner" />
  </Flex>
);
